<template>
  <div>
    <div
      class="px-4 sm:px-6 md:px-8 mb-8 flex items-center justify-between flex-wrap sm:flex-no-wrap"
    >
      <div>
        <h1 class="text-2xl font-semibold text-gray-900">Clips</h1>
      </div>
      <div class="flex-shrink-0"></div>
    </div>

    <div class="mx-auto px-4 sm:px-6 md:px-8 mt-4">
      <div class="flex flex-col">
        <div
          class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
        >
          <div class="bg-white shadow overflow-hidden sm:rounded-md">
            <div
              class="bg-white px-4 py-3 flex items-center justify-end border-b border-gray-200 sm:px-6"
            >
              <div class="flex">
                <div class="mr-2 rounded-md shadow-sm">
                  <select
                    v-model="game_id"
                    id="game_id"
                    class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 max-w-2xs"
                  >
                    <option value="all">Tous</option>
                    <option
                      v-for="game in games"
                      :key="game.id"
                      :value="game.id"
                      >{{ game.name }}</option
                    >
                  </select>
                </div>
                <div class="rounded-md shadow-sm">
                  <select
                    v-model="period"
                    id="period"
                    class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 max-w-2xs"
                  >
                    <option value="all">Tous</option>
                    <option value="day">Jour</option>
                    <option value="week">Semaine</option>
                    <option value="month">Mois</option>
                  </select>
                </div>
              </div>
            </div>
            <div
              class="p-6 grid grid-cols-1 row-gap-5 col-gap-4 sm:grid-cols-6"
            >
              <clip-preview
                v-for="clip in currentPaginateClips"
                :key="clip.id"
                :clip="clip"
                @open-detail="openDetail"
              ></clip-preview>
            </div>
            <div
              class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6"
            >
              <div class="flex-1 flex justify-between sm:hidden">
                <a
                  href="#"
                  class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                >
                  Previous
                </a>
                <a
                  href="#"
                  class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                >
                  Next
                </a>
              </div>
              <div
                class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between"
              >
                <div>
                  <p class="text-sm leading-5 text-gray-700">
                    Affichage de
                    <span class="font-medium">{{ clips.from }}</span>
                    à
                    <span class="font-medium">{{ clips.to }}</span>
                    des
                    <span class="font-medium">{{ clips.total }}</span>
                    résultats
                  </p>
                </div>
                <div>
                  <nav class="relative z-0 inline-flex shadow-sm">
                    <button
                      type="button"
                      class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150"
                      aria-label="Previous"
                      @click="updatePage(clips.current_page - 1)"
                    >
                      <svg
                        class="h-5 w-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </button>
                    <button
                      @click="updatePage(index)"
                      v-for="index in paginationSteps"
                      :key="index"
                      type="button"
                      class="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                      :class="{ 'bg-gray-100': index === clips.current_page }"
                    >
                      {{ index }}
                    </button>
                    <button
                      type="button"
                      class="-ml-px relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150"
                      aria-label="Next"
                      @click="updatePage(clips.current_page + 1)"
                    >
                      <svg
                        class="h-5 w-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </button>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <view-clip-modal
      :open="openClip !== null"
      @close="closeViewClipModal"
      :clip="openClip"
    ></view-clip-modal>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import ClipPreview from "@/components/Clips/ClipPreview";
import ViewClipModal from "@/components/Clips/ViewClipModal";
export default {
    components: {
        ClipPreview,
        ViewClipModal
    },
    data() {
        return {
            openClip: null,
            game_id: "all",
            period: "all",
            page: null
        };
    },
    computed: {
        ...mapGetters("clip", ["clips", "currentPaginateClips"]),
        ...mapState("game", ["games"]),
        hasProjects() {
            return this.currentPaginateClips.length > 0;
        },
        paginationSteps() {
            const lastPage = this.clips.last_page;
            const currentPage = this.clips.current_page;
            if (lastPage < 8) {
                return Array.from({ length: lastPage }, (v, k) => k + 1);
            }
            if ((currentPage === 1 && lastPage >= 8) || currentPage + 3 > lastPage) {
                return [1, 2, 3, "...", lastPage - 2, lastPage - 1, lastPage];
            }
            if (currentPage <= lastPage / 2 && lastPage >= 8) {
                return [
                    currentPage - 1,
                    currentPage,
                    currentPage + 1,
                    "...",
                    lastPage - 2,
                    lastPage - 1,
                    lastPage
                ];
            }
            if (currentPage > lastPage / 2 && lastPage >= 8) {
                return [1, 2, 3, "...", currentPage - 1, currentPage, currentPage + 1];
            }

            return [];
        }
    },
    methods: {
        openDetail(clip) {
            this.openClip = clip;
        },
        closeViewClipModal() {
            this.openClip = null;
        },
        getClips() {
            this.$store
                .dispatch("clip/get", {
                    "page[number]": this.page,
                    game: this.game_id === "all" ? null : this.game_id,
                    period: this.period === "all" ? null : this.period
                })
                .then(({ data }) => {
                    if (!this.paginationSteps.includes(data.data.current_page)) {
                        this.page = 1;
                    }
                });
        },
        updatePage(page) {
            if (typeof page === "number") {
                this.page = page;
            }
        }
    },
    watch: {
        page() {
            this.getClips();
        },
        game_id() {
            this.getClips();
        },
        period() {
            this.getClips();
        }
    },
    mounted() {
        this.$store.dispatch("clip/get");
    }
};
</script>
